import styled from "styled-components";

export const ButtonWrapper = styled.button`
    display: block;
    width: 100%;
    border: 0;
    cursor: pointer;
    background-color: ${({ theme }) => theme.color.white};
    border: 0.0625rem solid ${({ theme }) => theme.color.extraLight};
    padding: 0.3125rem;
    border-radius: 0.25rem;
    position: relative;
    z-index: 5;
    background-color: ${({ theme }) => theme.color.white};

    a {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::before,
    &::after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
    
    &::before {
        height: 4px;
        width: 98%;
        background-color: ${({ theme }) => theme.color.light};
        bottom: -4px;
        z-index: 1;
        
    }

    &::after {
        height: 3px;
        width: 96%;
        background-color: ${({ theme }) => theme.color.extraLight};
        bottom: -7px;
        z-index: 0;
    }

    .Column {

        display: flex;
        align-items: center;

        &:first-child {
            .AwesomeIcon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 38px;
            height: 38px;
            border-radius: 4px;
            background-color: ${props => props.theme[props.theming]?.colors.active_offers_color};

            svg {
                height: 15px;
                width: auto;

                path {
                    fill: ${({ theme }) => theme.color.white};
                }
            }
        }
        }

        &:last-child {

            .AwesomeIcon {
                padding-right: 0.625rem;

                svg {
                    height: 0.8125rem;
                    width: auto;

                    path {
                        fill: ${({ theme }) => theme.color.gray};
                    }
                }
            }
        }
    }
    }
`;

export const Column = styled.div`
    display: flex;
`;

export const ButtonIcon = styled.div``;

export const Text = styled.p`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: ${({ theme }) => theme.color.grayBold};
    font-weight: ${({ theme }) => theme.fontWeight.fw400};
    font-size: 0.8125rem;
    margin: 0;
    margin-left: 10px;
`;

export const ActiveOffersText = styled.span`
    color: ${({ theme }) => theme.color.black};
    font-weight: ${({ theme }) => theme.fontWeight.fw400};
    margin-left: 4px;
`;

export const ActiveOffersNumber = styled.span`
    color: ${({ theme }) => theme.color.black};
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    margin-left: 4px;
`;